.fieldContainer {
    margin: 0px 10px 10px 10px;
}